import type { AccountType, Actor, JwtPayload } from "./types";

/** Decode JWT payload without signature verification (middleware UX only). */
export function decodeJwtPayload(
  token: string,
  options?: { ignoreExpiry?: boolean },
): JwtPayload | null {
  try {
    const parts = token.split(".");
    if (parts.length !== 3) return null;

    const base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64)) as JwtPayload;

    if (
      !options?.ignoreExpiry &&
      payload.exp != null &&
      payload.exp * 1000 < Date.now()
    ) {
      return null;
    }

    if (!payload.sub || !payload.type) return null;
    return payload;
  } catch {
    return null;
  }
}

export function actorFromJwt(payload: JwtPayload): Actor {
  return {
    id: payload.sub,
    type: payload.type,
    roles: payload.roles,
    isAdmin: payload.type !== "customer",
  };
}

export function isAccountType(value: string): value is AccountType {
  return (
    value === "owner" ||
    value === "shop_admin" ||
    value === "staff" ||
    value === "customer"
  );
}
